// =============================================================
// Markdown rendering — kept here so ChatPage is the only consumer.
// Uses marked + DOMPurify, identical to original index.html.
// =============================================================

import { marked } from 'marked'
import DOMPurify from 'dompurify'

/**
 * Render assistant text as sanitized HTML.
 * Configures marked for safe output (GFM off; no raw HTML).
 */
export function renderMarkdown(text: string): string {
  const raw = marked.parse(text || '', { async: false }) as string
  return DOMPurify.sanitize(raw)
}